import { RichTextContent } from './index';

interface LexicalNode {
  text?: string;
  children?: LexicalNode[];
  type: string;
}

const getRichTextSummary = (
  data?: RichTextContent,
  maxLength = 10000,
): string => {
  if (!data) return '';

  const extract = (node: LexicalNode): string => {
    if (!node) return '';
    if (node.text) return node.text;
    if (node.children) return node.children.map(extract).join('');
    return '';
  };

  const text = extract(data.root);
  return maxLength ? text.slice(0, maxLength) : text;
};

export default getRichTextSummary;
